// ============================================
// ULTIMATE WEBSITE PROTECTION SCRIPT
// ============================================

(function() {
    'use strict';

    // ============================================
    // 1. DISABLE RIGHT-CLICK CONTEXT MENU
    // ============================================
    document.addEventListener('contextmenu', function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }, true);

    // ============================================
    // 2. DISABLE TEXT SELECTION
    // ============================================
    document.addEventListener('selectstart', function(e) {
        e.preventDefault();
        return false;
    }, true);

    document.addEventListener('mousedown', function(e) {
        if (e.detail > 1) { // Prevent double-click selection
            e.preventDefault();
            return false;
        }
    }, true);

    // ============================================
    // 3. DISABLE COPY, CUT, PASTE
    // ============================================
    ['copy', 'cut', 'paste'].forEach(function(event) {
        document.addEventListener(event, function(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }, true);
    });

    // ============================================
    // 4. DISABLE DRAG AND DROP
    // ============================================
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function(event) {
        document.addEventListener(event, function(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }, true);
    });

    // ============================================
    // 5. DISABLE ALL KEYBOARD SHORTCUTS
    // ============================================
    document.addEventListener('keydown', function(e) {
        var key = e.key ? e.key.toLowerCase() : '';
        var keyCode = e.keyCode || e.which;
        var ctrlKey = e.ctrlKey || e.metaKey; // metaKey for Mac
        var shiftKey = e.shiftKey;
        var altKey = e.altKey;

        // --- Block F-keys ---
        // F1-F12
        if (keyCode >= 112 && keyCode <= 123) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        // --- Block Ctrl combinations ---
        if (ctrlKey) {
            var blockedKeys = [
                'a', // Select All
                'c', // Copy
                'x', // Cut
                'v', // Paste
                's', // Save
                'p', // Print
                'u', // View Source
                'o', // Open File
                'j', // Console (Ctrl+J in some browsers)
                'h', // History
                'd', // Bookmark
                'e', // Search bar
                'f', // Find
                'g', // Find Next
                'k', // Search bar
                'l', // Address bar
                'n', // New Window
                't', // New Tab
                'w', // Close Tab
                'r', // Reload
                'b', // Bookmarks
                'i', // Dev Tools
                'q', // Quit
                'm', // Minimize
                'y', // Redo / History
                'z', // Undo
            ];

            if (blockedKeys.indexOf(key) !== -1) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            // Ctrl+Shift combinations
            if (shiftKey) {
                var blockedShiftKeys = [
                    'i', // Developer Tools
                    'j', // Console
                    'c', // Inspector
                    'k', // Console (Firefox)
                    'm', // Responsive Design Mode
                    'e', // Network (Firefox)
                    'q', // Console (Firefox)
                    's', // Debugger (Firefox)
                    'v', // Paste Special
                    'n', // Incognito
                    'p', // Incognito (Firefox)
                    'b', // Bookmarks
                    'o', // Bookmarks
                    'd', // Bookmarks
                    'delete', // Clear cache
                    'r', // Hard Reload
                    't', // Reopen Tab
                    'a', // About/Extensions
                    'u', // View Source Formatted
                    'h', // History
                ];

                if (blockedShiftKeys.indexOf(key) !== -1) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            }

            // Ctrl+number keys (switch tabs)
            if (keyCode >= 48 && keyCode <= 57) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            // Ctrl+Alt combinations
            if (altKey) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        }

        // --- Block Alt combinations ---
        if (altKey) {
            var blockedAltKeys = [
                'd', // Address bar
                'f4', // Close window
                'home', // Home page
                'left', // Back
                'right', // Forward
            ];
            if (blockedAltKeys.indexOf(key) !== -1) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            // Alt+F - File menu
            if (key === 'f') {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            // Alt+V - View menu
            if (key === 'v') {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        }

        // --- Block PrintScreen ---
        if (keyCode === 44) { // PrintScreen
            e.preventDefault();
            e.stopPropagation();
            // Clear clipboard
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText('');
            }
            return false;
        }

        // --- Block Escape key ---
        if (keyCode === 27) {
            e.preventDefault();
            return false;
        }

        // --- Block Windows/Meta key ---
        if (keyCode === 91 || keyCode === 92 || keyCode === 93) {
            e.preventDefault();
            return false;
        }

    }, true);

    // Also block keyup and keypress
    document.addEventListener('keyup', function(e) {
        var keyCode = e.keyCode || e.which;
        // Block PrintScreen on keyup (some browsers fire it here)
        if (keyCode === 44) {
            e.preventDefault();
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText('');
            }
            return false;
        }
    }, true);

    document.addEventListener('keypress', function(e) {
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
            return false;
        }
    }, true);

    // ============================================
    // 6. DISABLE PRINT
    // ============================================
    window.addEventListener('beforeprint', function(e) {
        e.preventDefault();
        // Hide content during print
        document.body.style.display = 'none';
        return false;
    }, true);

    window.addEventListener('afterprint', function() {
        document.body.style.display = '';
    }, true);

    // Override window.print
    window.print = function() {
        return false;
    };

    // ============================================
    // 7. DISABLE VIEW SOURCE
    // ============================================
    // Override Ctrl+U behavior already handled in keyboard section
    // Additional: block 'view-source:' protocol
    if (window.location.protocol === 'view-source:') {
        window.location.href = 'about:blank';
    }

    // ============================================
    // 8. DETECT AND BLOCK DEVTOOLS
    // ============================================
    var devToolsOpened = false;

    // Method 1: Check window dimensions
    function checkDevTools() {
        var threshold = 160;
        var widthDiff = window.outerWidth - window.innerWidth;
        var heightDiff = window.outerHeight - window.innerHeight;

        if (widthDiff > threshold || heightDiff > threshold) {
            if (!devToolsOpened) {
                devToolsOpened = true;
                onDevToolsOpen();
            }
        } else {
            devToolsOpened = false;
        }
    }

    // Method 2: debugger statement loop
    function debuggerLoop() {
        setInterval(function() {
            var start = performance.now();
            debugger;
            var end = performance.now();
            if (end - start > 100) {
                onDevToolsOpen();
            }
        }, 1000);
    }

    // Method 3: Console detection via toString
    function detectConsole() {
        var element = new Image();
        Object.defineProperty(element, 'id', {
            get: function() {
                onDevToolsOpen();
                return '';
            }
        });
        setInterval(function() {
            console.log('%c', element);
            console.clear();
        }, 1000);
    }

    // Method 4: Detect Firebug
    function detectFirebug() {
        if (window.console && (console.firebug || console.exception)) {
            onDevToolsOpen();
        }
    }

    // Method 5: Monitor console object changes
    function monitorConsole() {
        var originalConsole = window.console;
        Object.defineProperty(window, 'console', {
            get: function() {
                onDevToolsOpen();
                return originalConsole;
            },
            set: function(val) {
                return val;
            }
        });
    }

    function onDevToolsOpen() {
        // Option 1: Redirect
        // window.location.href = 'about:blank';

        // Option 2: Clear the page
        document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;font-family:Arial;font-size:24px;color:red;background:#000;"><h1>⚠️ Developer Tools Detected! Access Denied. ⚠️</h1></div>';

        // Option 3: Infinite redirect loop
        // window.location.replace(window.location.href);
    }

    setInterval(checkDevTools, 500);
    debuggerLoop();

    try {
        detectConsole();
    } catch(e) {}

    detectFirebug();

    // ============================================
    // 9. DISABLE CONSOLE METHODS
    // ============================================
    (function() {
        var methods = ['log', 'debug', 'info', 'warn', 'error', 'table',
                       'trace', 'dir', 'dirxml', 'group', 'groupCollapsed',
                       'groupEnd', 'time', 'timeEnd', 'timeLog', 'profile',
                       'profileEnd', 'assert', 'count', 'countReset'];

        methods.forEach(function(method) {
            if (console[method]) {
                console[method] = function() {};
            }
        });
    })();

    // ============================================
    // 10. DISABLE SAVE AS (ADDITIONAL)
    // ============================================
    document.addEventListener('keydown', function(e) {
        // Ctrl+S
        if ((e.ctrlKey || e.metaKey) && e.keyCode === 83) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }, true);

    // ============================================
    // 11. DISABLE IMAGE DOWNLOAD / PROTECTION
    // ============================================
    document.addEventListener('DOMContentLoaded', function() {
        // Disable dragging on all images
        var images = document.querySelectorAll('img');
        images.forEach(function(img) {
            img.setAttribute('draggable', 'false');
            img.addEventListener('contextmenu', function(e) {
                e.preventDefault();
                return false;
            });
            img.addEventListener('dragstart', function(e) {
                e.preventDefault();
                return false;
            });
            // Add pointer-events overlay
            img.style.pointerEvents = 'none';
        });

        // Also apply to dynamically added images
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.tagName === 'IMG') {
                        node.setAttribute('draggable', 'false');
                        node.style.pointerEvents = 'none';
                    }
                    if (node.querySelectorAll) {
                        node.querySelectorAll('img').forEach(function(img) {
                            img.setAttribute('draggable', 'false');
                            img.style.pointerEvents = 'none';
                        });
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    // ============================================
    // 12. DISABLE CLIPBOARD ACCESS
    // ============================================
    if (navigator.clipboard) {
        // Override clipboard API
        Object.defineProperty(navigator, 'clipboard', {
            get: function() {
                return {
                    writeText: function() { return Promise.reject('Blocked'); },
                    readText: function() { return Promise.reject('Blocked'); },
                    write: function() { return Promise.reject('Blocked'); },
                    read: function() { return Promise.reject('Blocked'); }
                };
            }
        });
    }

    // Override document.execCommand for copy
    var originalExecCommand = document.execCommand;
    document.execCommand = function(command) {
        if (command === 'copy' || command === 'cut' || command === 'paste') {
            return false;
        }
        return originalExecCommand.apply(document, arguments);
    };

    // ============================================
    // 13. DISABLE POINTER EVENTS TRICKS
    // ============================================
    document.addEventListener('pointerdown', function(e) {
        if (e.pointerType === 'mouse' && e.button === 2) {
            e.preventDefault();
            return false;
        }
    }, true);

    // ============================================
    // 14. PREVENT IFRAME EMBEDDING
    // ============================================
    if (window.top !== window.self) {
        window.top.location = window.self.location;
    }

    // ============================================
    // 15. DISABLE BROWSER EXTENSIONS DETECTION
    // ============================================
    // Block common extension injection points
    var blockedAttributes = ['data-reactroot', '__vue__'];

    // Monitor for extension-injected elements
    var extensionObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    // Check for common extension patterns
                    var id = node.id || '';
                    var className = node.className || '';
                    if (id.match(/^(firebug|webdeveloper|react-devtools)/i) ||
                        className.toString().match(/^(firebug|webdeveloper)/i)) {
                        node.remove();
                    }
                }
            });
        });
    });

    extensionObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true
    });

    // ============================================
    // 16. OVERRIDE WINDOW.OPEN TO PREVENT
    //     VIEW-SOURCE WINDOWS
    // ============================================
    var originalOpen = window.open;
    window.open = function(url) {
        if (url && url.toString().indexOf('view-source') !== -1) {
            return null;
        }
        return originalOpen.apply(window, arguments);
    };

    // ============================================
    // 17. DISABLE SCREEN CAPTURE API
    // ============================================
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices.getDisplayMedia = function() {
            return Promise.reject(new Error('Screen capture is disabled'));
        };
    }

    // ============================================
    // 18. PREVENT BLOB AND DATA URL ACCESS
    // ============================================
    var originalCreateObjectURL = URL.createObjectURL;
    URL.createObjectURL = function(obj) {
        if (obj instanceof Blob && obj.type.indexOf('text/html') !== -1) {
            return 'about:blank';
        }
        return originalCreateObjectURL.apply(URL, arguments);
    };

    // ============================================
    // 19. DISABLE ACCESSIBILITY TOOLS ABUSE
    // ============================================
    document.addEventListener('focusin', function(e) {
        // Prevent focus-based content extraction
    }, true);

    // ============================================
    // 20. PREVENT AUTOMATED SCRAPING
    // ============================================
    // Detect headless browsers
    (function() {
        var isAutomated = (
            navigator.webdriver ||
            window.__nightmare ||
            window.callPhantom ||
            window._phantom ||
            window.phantom ||
            navigator.languages === undefined ||
            navigator.languages.length === 0 ||
            navigator.plugins.length === 0
        );

        if (isAutomated) {
            document.body.innerHTML = '';
            window.location.href = 'about:blank';
        }
    })();

    // ============================================
    // 21. DISABLE TOUCH LONG PRESS (MOBILE)
    // ============================================
    document.addEventListener('touchstart', function(e) {
        if (e.touches.length > 1) {
            e.preventDefault();
        }
    }, { passive: false });

    var touchTimer;
    document.addEventListener('touchstart', function(e) {
        touchTimer = setTimeout(function() {
            e.preventDefault();
        }, 500);
    }, { passive: false });

    document.addEventListener('touchend', function() {
        clearTimeout(touchTimer);
    }, true);

    document.addEventListener('touchmove', function() {
        clearTimeout(touchTimer);
    }, true);

    // ============================================
    // 22. PREVENT FETCH/XHR PAGE SOURCE
    // ============================================
    var originalFetch = window.fetch;
    window.fetch = function(url) {
        if (typeof url === 'string') {
            var currentUrl = window.location.href;
            var currentOrigin = window.location.origin;
            if (url === currentUrl || url === currentOrigin + '/' ||
                url === '/' || url === '' || url === '.') {
                return Promise.reject(new Error('Blocked'));
            }
        }
        return originalFetch.apply(window, arguments);
    };

    var originalXHR = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
        var currentUrl = window.location.href;
        if (url === currentUrl || url === '/' || url === window.location.pathname) {
            throw new Error('Blocked');
        }
        return originalXHR.apply(this, arguments);
    };

    // ============================================
    // 23. VISIBILITY CHANGE - CLIPBOARD CLEAR
    // ============================================
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
            // Clear clipboard when user switches tabs
            if (navigator.clipboard && navigator.clipboard.writeText) {
                try {
                    navigator.clipboard.writeText('');
                } catch(e) {}
            }
        }
    });

    // ============================================
    // 24. PREVENT BOOKMARK JAVASCRIPT
    // ============================================
    // Block javascript: protocol
    document.addEventListener('click', function(e) {
        var target = e.target;
        while (target) {
            if (target.href && target.href.startsWith('javascript:')) {
                e.preventDefault();
                return false;
            }
            target = target.parentElement;
        }
    }, true);

    // ============================================
    // 25. CONSOLE WARNING MESSAGE
    // ============================================
    console.log('%c⚠️ STOP!', 'color: red; font-size: 50px; font-weight: bold;');
    console.log('%cThis browser feature is intended for developers. Do not copy-paste anything here.',
                'color: red; font-size: 18px;');

})();